import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const MyButton = ({
  customFunc,
  text,
  icon,
  ClassName,
  ClassColor,
  condition,
  hiddenOnCondition,
  loading,
  rightIcon,
}) => {
  return (
    <>
      {!hiddenOnCondition && (
        <button
          className={`${ClassName} ${ClassColor} ${
            condition ? '' : `hover:${ClassColor}/90`
          } flex items-center justify-center gap-2 rounded-md p-2 font-semibold`}
          disabled={condition}
          onClick={customFunc}
          style={{ opacity: condition ? '50%' : '100%', color: '#fff' }}
          type="button"
        >
          {loading ? (
            <span className="flex items-center">
              <FontAwesomeIcon
                aria-hidden="true"
                className="h-5 w-5 animate-spin text-white"
                icon={icon}
              />
            </span>
          ) : (
            ''
          )}
          <p className="capitalize">{text}</p>
          {rightIcon && (
            <FontAwesomeIcon className="h-5 w-5 text-white" icon={rightIcon} />
          )}
        </button>
      )}
    </>
  )
}

export default MyButton

MyButton.propTypes = {
  customFunc: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.any,
  ClassName: PropTypes.string,
  ClassColor: PropTypes.string,
  condition: PropTypes.bool,
  hiddenOnCondition: PropTypes.bool,
  loading: PropTypes.bool,
  rightIcon: PropTypes.any,
}
